import { createRoot } from 'react-dom/client';

import ScrollToTop from '@components/ScrollToTop';
import ToastContainer from '@components/ToastContainer';

const selector = document.querySelector('#js-scroll-top');

if (selector) {
  const root = createRoot(selector);

  root.render(
    <>
      <ToastContainer />
      <ScrollToTop />
    </>,
  );
}
